


















import Modal from "../core/Modals/Modal.vue";
import EditionModal from "../core/Modals/EditionModal.vue";
import { EmployeApi } from "../api/EmployeApi";
import { Employe } from "../models/Employe";
import ContratModalEdit from "./ContratModalPartials/ContratModalEdit.vue";
import Contrat = Employe.Contrat;

export default {
    name: "ContratModal",
    components: { ContratModalEdit, EditionModal, Modal },
    props: {
        employeId: Number,
        contratId: Number,
        isNew: Boolean,
    },
    data() {
        return {
            showModal: false,
            contrat: null,
            fetching: true,
            editing: false,
            EmployeApi: new EmployeApi(),
            editable: true,
            saving: false,
        };
    },
    created() {
        var self = this;
    },
    watch: {
        contratId: function (newVal): void {
            var self = this;

            self.showModal = _.isNumber(newVal) && _.isNumber(this.employeId);
            if (self.showModal) {
                self.fetching = true;
                self.EmployeApi.getContrat(self.employeId, self.contratId).then(
                    function (res) {
                        self.contrat = res;
                        self.fetching = false;
                        self.editing = true;
                    }
                );
            }
        },
        isNew: {
            immediate: true,
            handler: function (newVal): void {
                if (newVal) {
                    this.contrat = new Contrat({});
                    this.creationModal();
                }
            },
        },
    },
    methods: {
        closeModal: function (): void {
            this.showModal = false;
        },
        saveContrat: function (): Promise<Contrat> {
            let self = this;
            if (!self.formIsComplete()) {
                swal(
                    "Erreur lors de la sauvegarde.",
                    "Données incomplètes.",
                    "error"
                );
                return;
            }
            if (self.saving) {
                return;
            } else {
                self.saving = true;
            }
            return self.EmployeApi.saveContrat(
                self.employeId,
                self.contrat
            ).then(function (res) {
                self.$emit("data-saved", self.contrat);
                self.saving = false;
                return res;
            });
        },
        creationModal: function (): void {
            this.showModal = true;
            this.fetching = false;
            this.editing = true;
        },
        formIsComplete(): boolean {
            return this.contrat.start_date && this.contrat.hours;
        },
    },
};
